import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-11-13
	day7ScheduleOrderCount() {
		return axios.get('/weddingDressHall/workbench/day7-schedule-order-count')
	},
	// 2021-11-13
	collectionStatistics() {
		return axios.get('/weddingDressHall/workbench/collection-statistics')
	},
	//=====
	// 2021-11-15
	scheduleStatistics(params) {
		return axios.get('/weddingDressHall/workbench/schedule-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-11-16
	scheduleStatisticsDetail(params) {
		return axios.get('/weddingDressHall/workbench/schedule-statistics-detail?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},

	// 2021-11-16
	scheduleFinishStatistics(params) {
		return axios.get('/weddingDressHall/workbench/schedule-finish-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},

	// 2021-11-16
	rentSourceStatistics(params) {
		return axios.get('/weddingDressHall/workbench/rent-source-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},

	// 2021-11-16
	rentSourceStatisticsDetail(params) {
		return axios.get('/weddingDressHall/workbench/rent-source-statistics-detail?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},

	// 2021-11-16
	hotProductNoStatistics(params) {
		return axios.get('/weddingDressHall/workbench/hot-product-no-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-11-16
	hotPackageStatistics(params) {
		return axios.get('/weddingDressHall/workbench/hot-package-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-11-16
	supplierContributionStatistics(params) {
		return axios.get('/weddingDressHall/workbench/supplier-contribution-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-11-16
	supplierContributionStatisticsDetail(params) {
		return axios.get('/weddingDressHall/workbench/supplier-contribution-statistics-detail?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},

	// 2021-11-16
	saleStatistics(params) {
		return axios.get('/weddingDressHall/workbench/sale-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},

	// 2021-11-30
	cleanStatistics(params) {
		return axios.get('/weddingDressHall/workbench/clean-statistics?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-11-30
	cleanStatisticsDetail(params) {
		return axios.get('/weddingDressHall/workbench/clean-statistics-detail?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-11-30
	serviceItems(params) {
		return axios.get('/weddingDressHall/workbench/service-items?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
}

